import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Phone, Mail, Clock, MessageCircle } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Mensagem enviada! Respondemos em 24-48h.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Erro ao enviar"); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-6xl px-4 py-12">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Fala connosco</div>
        <h1 className="text-4xl sm:text-5xl font-display font-bold">Contacto</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">Estamos aqui para te ajudar. Resposta média em 24-48h úteis.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="space-y-4">
          <a href="tel:+351929163121" className="block rounded-2xl border border-border p-5 hover:border-primary transition-colors" data-testid="contact-phone-card">
            <Phone className="w-5 h-5 text-primary mb-2" />
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Telefone</div>
            <div className="font-medium mt-1">+351 929 163 121</div>
          </a>
          <a href="https://wa.me/351929163121" target="_blank" rel="noopener noreferrer" className="block rounded-2xl border border-border p-5 hover:border-primary transition-colors" data-testid="contact-whatsapp-card">
            <MessageCircle className="w-5 h-5 text-primary mb-2" />
            <div className="text-xs uppercase tracking-widest text-muted-foreground">WhatsApp</div>
            <div className="font-medium mt-1">Chat direto</div>
          </a>
          <a href="mailto:support@voltix.com" className="block rounded-2xl border border-border p-5 hover:border-primary transition-colors">
            <Mail className="w-5 h-5 text-primary mb-2" />
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Email</div>
            <div className="font-medium mt-1">support@voltix.com</div>
          </a>
          <div className="rounded-2xl border border-border p-5">
            <Clock className="w-5 h-5 text-primary mb-2" />
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Horário</div>
            <div className="font-medium mt-1">Seg-Sex 9h-18h (WET)</div>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-2 rounded-2xl border border-border p-6 bg-card space-y-4">
          <h3 className="font-display font-semibold text-lg">Envia-nos uma mensagem</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            <div><Label>Nome</Label><Input required value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} data-testid="contact-name" /></div>
            <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} data-testid="contact-email" /></div>
          </div>
          <div><Label>Assunto</Label><Input value={form.subject} onChange={(e)=>setForm({...form,subject:e.target.value})} data-testid="contact-subject" /></div>
          <div><Label>Mensagem</Label><Textarea rows={6} required value={form.message} onChange={(e)=>setForm({...form,message:e.target.value})} data-testid="contact-message" /></div>
          <Button type="submit" size="lg" className="rounded-full btn-primary" disabled={loading} data-testid="contact-submit">
            {loading ? "A enviar..." : "Enviar mensagem"}
          </Button>
        </form>
      </div>
    </div>
  );
}
